var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sidebar-left" }, [
    _c("div", { staticClass: "sidebar-body scroll-pane" }, [
      _c(
        "div",
        { staticClass: "side-nav" },
        [
          _c(
            "v-collapse",
            { ref: "allLinks", attrs: { accordion: "" } },
            [
              this.$can("tasksList")
                ? _c("v-collapse-item", { attrs: { "active-url": "/tasks" } }, [
                    _c(
                      "a",
                      {
                        attrs: { slot: "item-title", href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.mixinGoToRouter("TasksList")
                          },
                        },
                        slot: "item-title",
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-tasks" }),
                        _vm._v("Задачи\n            "),
                        _vm.$ActiveNotifications &&
                        +_vm.$ActiveNotifications.dialogs
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "badge badge-info order_info_badge",
                              },
                              [_vm._v(_vm._s(_vm.$ActiveNotifications.dialogs))]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$can("clientsChats")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/customersRequests/chats" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("ClientsChats")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-wechat" }),
                          _vm._v("Чаты с клиентами\n            "),
                          _vm.$ActiveNotifications &&
                          +_vm.$ActiveNotifications.activeChatDialogs
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-info order_info_badge",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$ActiveNotifications.activeChatDialogs
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              false
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/notifications" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("Notifications")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-paper-plane",
                          }),
                          _vm._v("Уведомления\n            "),
                          _vm.$ActiveNotifications &&
                          +_vm.$ActiveNotifications.dialogs
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-info order_info_badge",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$ActiveNotifications.dialogs)
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      false
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-info order_info_badge",
                            },
                            [_vm._v("10")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$currentRole !== "partner"
                ? _c("v-collapse-item", { attrs: { "active-url": "/" } }, [
                    _c(
                      "a",
                      {
                        attrs: { slot: "item-title", href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.mixinGoToRouter("home")
                          },
                        },
                        slot: "item-title",
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-medkit" }),
                        _vm._v("Сводная панель\n          "),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$can("report/division/secretary", false)
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/reports/secretary" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter(
                                "DivisionSecretaryReport"
                              )
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-newspaper-o",
                          }),
                          _vm._v("Мой отчет\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("reports/operations/period", false)
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/reports/operations/period" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter(
                                "OperationsPeriodReport"
                              )
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-history" }),
                          _vm._v("Операции за период\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$currentRole !== "admin" && this.$can("runners/map")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runners/map" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("runnersMap")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-map-marker",
                          }),
                          _vm._v("Карта\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders/partnerOrders")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders/partner" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("PartnerOrders")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-medkit" }),
                          _vm._v("Заявки\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("OnlineStatus")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/online" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("OnlineStatus")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-eye" }),
                          _vm._v("Онлайн ситуация\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders/listManual" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            slot: "item-title",
                            to: "/orders/listManual",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter(
                                "listOrdersManual",
                                { type: "manual" },
                                $event
                              )
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-medkit" }),
                          _vm._v("Ручные заявки\n          "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "external_link",
                          attrs: {
                            target: "_blank",
                            href: _vm.getRouteLink("listOrdersManual"),
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-external-link",
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders/listDelivery" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "position-relative",
                          attrs: { slot: "item-title" },
                          slot: "item-title",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "listOrdersDelivery",
                                    { type: "delivery" }
                                  )
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-medkit",
                              }),
                              _vm._v("Доставки с сайтов\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "external_link",
                              attrs: {
                                target: "_blank",
                                href: _vm.getRouteLink("listOrdersDelivery"),
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-external-link",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          false && _vm.ordersCountDetails.delivery
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-info order_info_badge",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.ordersCountDetails.delivery)
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders/listpost" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "position-relative",
                          attrs: { slot: "item-title" },
                          slot: "item-title",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("listOrdersPost", {
                                    type: "post",
                                  })
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-medkit",
                              }),
                              _vm._v("Почтовые заявки\n            "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "external_link",
                              attrs: {
                                target: "_blank",
                                href: _vm.getRouteLink("listOrdersPost"),
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-external-link",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          false && _vm.ordersCountDetails.post
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-info order_info_badge",
                                },
                                [_vm._v(_vm._s(_vm.ordersCountDetails.post))]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders/newOrder")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders/new" } },
                    [
                      this.$can("orders/newOrder")
                        ? _c(
                            "a",
                            {
                              attrs: { slot: "item-title", href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("newOrder")
                                },
                              },
                              slot: "item-title",
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-medkit",
                              }),
                              _vm._v("Создать заявку\n          "),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("profile")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/profile/orders" } },
                    [
                      this.$can("profile/personalOrders")
                        ? _c(
                            "a",
                            {
                              attrs: {
                                slot: "item-title",
                                href: "#",
                                "active-url": "/profile/orders",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "profilePersonalOrders"
                                  )
                                },
                              },
                              slot: "item-title",
                            },
                            [_vm._v("\n            Заявки\n          ")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders/newOrder")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders/searchRefund" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Спец заявка\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("orders/listOrders")
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                                "active-url": "/orders/searchRefund",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "searchOrderRefund"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Возврат\n          ")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders/search")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders/search" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("searchOrder")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-search" }),
                          _vm._v("Поиск заявок\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("stores/group")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/stores" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-archive" }),
                          _vm._v("Остатки на складах\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("stores/allStoresStatus")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/stores/status",
                              },
                              attrs: { "active-url": "/stores/status" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("storesStatus")
                                },
                              },
                            },
                            [
                              _vm._v("Все склады"),
                              this.$can("stores/status/autoAdjust")
                                ? _c("span", [_vm._v(" + ревизия")])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("stores/selectStoreStatus")
                        ? _c(
                            "a",
                            {
                              class: {
                                active: _vm.$route.fullPath === "/stores/all",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("BranchStores")
                                },
                              },
                            },
                            [_vm._v("Склад")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("stores/status/autoAdjust")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/stores/adjustments",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("StoreAdjustments")
                                },
                              },
                            },
                            [_vm._v("История ревизий")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("stores/status/correction")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/stores/status/correction",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("StoreCorrection")
                                },
                              },
                            },
                            [_vm._v("Коррекция")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("stores/revision")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/stores/revision",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("StoreRevision")
                                },
                              },
                            },
                            [_vm._v("Ревизия")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("stores/revision")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/stores/revInvoice",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("RevisionInvoice")
                                },
                              },
                            },
                            [_vm._v("Сдэк")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("stores/revision")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/stores/revInvoiceLight",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "RevisionInvoiceLight"
                                  )
                                },
                              },
                            },
                            [_vm._v("Сдэк2")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("stores/revision")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/stores/revision/invoice/income",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "RevisionIncomeInvoice"
                                  )
                                },
                              },
                            },
                            [_vm._v("Турция")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("stores/revision")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/stores/drugs/dimensions",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("DrugsDimensions")
                                },
                              },
                            },
                            [_vm._v("Габариты препаратов")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("stores/SendByPost")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/stores/postsend" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            slot: "item-title",
                            href: "#",
                            "active-url": "/stores/postsend",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("SendOrdersByPost")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dropbox" }),
                          _vm._v("Отправка заявок\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Заявки\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("orders/listOrders")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("listOrders")
                                },
                              },
                            },
                            [_vm._v("\n            Все заявки\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/newOrder")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("newOrder")
                                },
                              },
                            },
                            [_vm._v("\n            Создать заявку\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/search")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("searchOrder")
                                },
                              },
                            },
                            [_vm._v("Поиск заявок")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/rejected")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("RejectedOrders")
                                },
                              },
                            },
                            [_vm._v("Отказы заявок")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/search")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/orders/posttrack",
                              },
                              attrs: {
                                href: "#",
                                "active-url": "/orders/posttrack",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("PostTrackNumbers")
                                },
                              },
                            },
                            [_vm._v("Трэк номера")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/outsource")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/orders/outsource",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("outsourceOrders")
                                },
                              },
                            },
                            [_vm._v("Партнерские")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/byInvoice")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/invoices/manage/orders",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "ManageInvoicesToOrders"
                                  )
                                },
                              },
                            },
                            [_vm._v("По поступлению")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/byInvoice")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/orders/postcf",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("PostCloseByFile")
                                },
                              },
                            },
                            [_vm._v("Закрыть по файлу")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("divisions")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Дивизионы\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("divisions/salary")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "divisionsSalaryHistory"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            ЗП курьеров\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("divisions/settings")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "divisionsSettings"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            настройки\n          ")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("autolists")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/autolists" } },
                    [
                      this.$can("autolists")
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                                "active-url": "/autolists/AutoList2",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("AutoList2")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Автосписок перемещения\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Авто списки\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("autolists/drugsOrderImport")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "drugsOrderImport2"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Заказ товара\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("autolists/overStore")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "AutolistOverStore"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Излишки\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("autolists/settings")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("AutolistSettings")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Настройки автосписка\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("invoices/transfersPlan")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/autolists/transfersplan",
                              },
                              attrs: {
                                href: "#",
                                "active-url": "/autolists/transfersplan",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("TransfersPlan")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            План трансферов\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("autolists/usefulStores")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/autolists/stores/useful",
                              },
                              attrs: {
                                href: "#",
                                "active-url": "/autolists/stores/useful",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "AutoListUsefulStore"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Полезный склад\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("autolists/PrepsInReserve")
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                                "active-url": "/autolists/prepsinreserve",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "AutolistsPrepsInReserve"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Брони препаратов\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("autolists/RejectedOrders")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "AutolistsRejectedOrders"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Отмененные препараты\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runner/AllRunnerOrders")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runners/orders" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            slot: "item-title",
                            href: "#",
                            "active-url": "/runners/orders",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("runnersOrdersList")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Обработка заявок\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runner/Invoices")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runners/invoices" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            slot: "item-title",
                            href: "#",
                            "active-url": "/runners/invoices",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("runnersInvoices")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Накладные\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runner/ordersToCall")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runner/ordersToCall" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("runnersOrdersToCall")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Заявки на обзвон\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runner/storageTasks")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runner/storage/tasks" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("runnersStorageTasks")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Задачи\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runner/Backpacks") ||
              _vm.$allowTo("use_backpack_system")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runner/backpacks" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("runnersBackpacks")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-medkit" }),
                          _vm._v("Рюкзаки\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runner/Backpacks") ||
              _vm.$allowTo("use_backpack_system")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runner/backpacksHistory" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter(
                                "runnersBackpacksResets"
                              )
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-medkit" }),
                          _vm._v("История рюкзаков\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runners/report")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runners/report" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("RunnerCurrentReport")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-medkit" }),
                          _vm._v("\n            Отчет\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runners/invoices")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runners/invoices" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("runnersInvoices")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-list-alt" }),
                          _vm._v("\n            Накладные\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runners/storeStatus")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/stores/status/list" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("StoreRemainStatus")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-list-alt" }),
                          _vm._v("\n            Остатки на складе\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("cod/orders")
                ? _c(
                    "v-collapse-item",
                    {
                      staticStyle: { opacity: ".3" },
                      attrs: { "active-url": "/cod/orders" },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            slot: "item-title",
                            href: "#",
                            "active-url": "/cod/orders",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("CodOrders")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Наложенный платеж\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("runner/orderTasks")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/runner/ordersToCall" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("runnersOrderTasks")
                            },
                          },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Задачи от курьеров\n          "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("projects")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/projects" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-share-alt" }),
                          _vm._v("Проекты\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("projectVisits")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            Статистика посещений\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("projects/blockLinksList")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/projects/blocklinks" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "ProjectsLinksBlockList"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Блокировки РКН\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("projects/blockList")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/projects/blockList" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "ProjectsBlockList"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Проверка РКН\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("files")
                ? _c("v-collapse-item", { attrs: { "active-url": "/files" } }, [
                    _c(
                      "a",
                      {
                        attrs: { slot: "item-title", href: "#" },
                        slot: "item-title",
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-files-o" }),
                        _vm._v("Файлы\n            "),
                        _c("span", { staticClass: "icon-fa arrow icon-fa-fw" }),
                      ]
                    ),
                    _vm._v(" "),
                    this.$can("files/download")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("FilesDownload")
                              },
                            },
                          },
                          [_vm._v("\n            скачать\n          ")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$can("drugs")
                ? _c("v-collapse-item", { attrs: { "active-url": "/drugs" } }, [
                    _c(
                      "a",
                      {
                        attrs: { slot: "item-title", href: "#" },
                        slot: "item-title",
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                        _vm._v("Препараты\n            "),
                        _c("span", { staticClass: "icon-fa arrow icon-fa-fw" }),
                      ]
                    ),
                    _vm._v(" "),
                    this.$can("drugs/siteEdit")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("DrugSiteEdit")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Редактирование на сайте\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/siteEdit")
                      ? _c(
                          "a",
                          {
                            class: {
                              active:
                                _vm.$route.fullPath === "/drugs/details/list",
                            },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("DrugsDetailsList")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Детали препаратов\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/projectFAQ")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("DrugProjectFAQ")
                              },
                            },
                          },
                          [_vm._v("\n            Вопрос/ответ\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/сreateTasks")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("CreateTasks")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Задания на создание\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/orderImport")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("drugsOrderImport")
                              },
                            },
                          },
                          [_vm._v("\n            Заказ товара\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/exportFromSite")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter(
                                  "exportDrugsFromSites"
                                )
                              },
                            },
                          },
                          [_vm._v("\n            Экспорт с сайтов\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/SidePrices")
                      ? _c(
                          "a",
                          {
                            class: {
                              active:
                                _vm.$route.fullPath === "/drugs/sideprices",
                            },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("DrugsSidePrices")
                              },
                            },
                          },
                          [_vm._v("\n            Цены для закупок\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/expireDates")
                      ? _c(
                          "a",
                          {
                            class: {
                              active:
                                _vm.$route.fullPath === "/drugs/expireDates",
                            },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("expireDates")
                              },
                            },
                          },
                          [_vm._v("\n            Сроки годности\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/uploadPhotos")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("uploadDrugsPhotos")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Загрузка фото на сайты\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/uploadNewPhotos")
                      ? _c(
                          "a",
                          {
                            class: {
                              active:
                                _vm.$route.fullPath ===
                                "/drugs/uploadNewPhotos",
                            },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter(
                                  "uploadNewDrugsPhotos"
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Загрузка новых фоторафий\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("drugs/storeStatus")
                      ? _c(
                          "a",
                          {
                            class: {
                              active:
                                _vm.$route.fullPath === "/drugs/store/status",
                            },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("DrugStoreStatus")
                              },
                            },
                          },
                          [_vm._v("\n            Статусы склада\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        class: {
                          active: _vm.$route.fullPath === "/drugs/comments",
                        },
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.mixinGoToRouter("DrugComments")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            Комментарии к препаратам\n          "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$can("egk/codes")
                ? _c("v-collapse-item", { attrs: { "active-url": "/egk" } }, [
                    _c(
                      "a",
                      {
                        attrs: { slot: "item-title", href: "#" },
                        slot: "item-title",
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                        _vm._v("ЕГК\n            "),
                        _c("span", { staticClass: "icon-fa arrow icon-fa-fw" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        class: {
                          active: _vm.$route.fullPath === "/egk/noactive",
                        },
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.mixinGoToRouter("noActiveEgkCodes")
                          },
                        },
                      },
                      [_vm._v("\n            Не активные\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.mixinGoToRouter("egkCodesModerated")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            Продукты Модерированные\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.mixinGoToRouter("egkCodesGrouped")
                          },
                        },
                      },
                      [_vm._v("\n            Продукты\n          ")]
                    ),
                    _vm._v(" "),
                    this.$can("egk/codesIgnored")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("egkCodesIgnored")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Продукты в игноре\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$can("analytics")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/analytics" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Аналитика\n            "),
                          +_vm.$ActiveNotifications?.scanMonitoringDrugsCount ||
                          +_vm.$ActiveNotifications?.scanDrugsModeration
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-info order_info_badge",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      +(
                                        _vm.$ActiveNotifications
                                          .scanMonitoringDrugsCount ?? 0
                                      ) +
                                        +(
                                          _vm.$ActiveNotifications
                                            .scanDrugsModeration ?? 0
                                        )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("analytics/nomenclature")
                        ? _c(
                            "v-collapse-item",
                            {
                              attrs: {
                                "active-url": "/analytics/nomenclature/",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { slot: "item-title", href: "#" },
                                  slot: "item-title",
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-list",
                                  }),
                                  _vm._v("Ассортимент\n              "),
                                  _c("span", {
                                    staticClass: "icon-fa arrow icon-fa-fw",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              this.$can("analytics/nomenclature/stat003")
                                ? _c(
                                    "a",
                                    {
                                      class: {
                                        active:
                                          _vm.$route.fullPath ===
                                          "/analytics/nomenclature/stat003",
                                      },
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "AnalyticsStat003Drugs"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Статистика 003")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("analytics/nomenclature/scan")
                                ? _c(
                                    "a",
                                    {
                                      class: {
                                        active:
                                          _vm.$route.fullPath ===
                                          "/analytics/nomenclature/scan",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "StatisticsDrugsScan"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Не активные препараты\n              "
                                      ),
                                      +_vm.$ActiveNotifications
                                        ?.scanDrugsModeration
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-info order_info_badge",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$ActiveNotifications
                                                    .scanDrugsModeration
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can(
                                "analytics/nomenclature/scan/tasks/done"
                              )
                                ? _c(
                                    "a",
                                    {
                                      class: {
                                        active:
                                          _vm.$route.fullPath ===
                                          "/analytics/nomenclature/scan/tasks/done",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "StatisticsDrugsScanTasksDone"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Срабатывание мониторинга\n              "
                                      ),
                                      +_vm.$ActiveNotifications
                                        ?.scanMonitoringDrugsCount
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-info order_info_badge",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$ActiveNotifications
                                                    .scanMonitoringDrugsCount
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("analytics/nomenclature/tasks")
                                ? _c(
                                    "a",
                                    {
                                      class: {
                                        active:
                                          _vm.$route.fullPath ===
                                          "/analytics/nomenclature/tasks",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "StatisticsDrugsTasks"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Задачи на обзвон\n            ")]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("analytics/managerRatings")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("ManagersRating")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Рейтинг менеджеров\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("analytics/managerActivities")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/analytics/managerActivities",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "ManagerActivities"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Активность менеджеров\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("analytics/orderStatistics")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("OrdersStatistics")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Статистика заявок\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("analytics/salePeriod")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("SalePeriod")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Продажа препаратов\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("analytics/profit")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("StatisticProfit")
                                },
                              },
                            },
                            [_vm._v("\n            Выторг\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("analytics/ordersgraph")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("OrdersGraph")
                                },
                              },
                            },
                            [_vm._v("\n            График заявок\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("revision")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/revision" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Ревизия\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("revision/correction")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "RevisionCorrection"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Корректировка\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("revision/divisions")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "DivisionsRevision"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Дивизионы\n          ")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("nomenclature")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/nomenclature" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Номенклатура\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("nomenclature/new")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/nomenclature/new",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("NewDrug")
                                },
                              },
                            },
                            [_vm._v("Новый препарат")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("nomenclature/editdrug")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/nomenclature/edit",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("EditDrug")
                                },
                              },
                            },
                            [_vm._v("Редактирование")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("nomenclature/revisions")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "nomenclatureRevisions"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Ревизии\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("nomenclature/synchronize")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "nomenclatureSynchronize"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Синхронизация\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("nomenclature/synchronize2")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "nomenclatureSynchronize2"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Ретро просчет\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("nomenclature/statistics")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "NomenclatureStatistics"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Движение препарата\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("BarCodesEdit")
                            },
                          },
                        },
                        [_vm._v("Штрих коды")]
                      ),
                      _vm._v(" "),
                      this.$can("nomenclature/manufacturers")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/nomenclature/manufacturers",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "NomenclatureManufacturers"
                                  )
                                },
                              },
                            },
                            [_vm._v("Производители")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("nomenclature/relatedDrugs")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/nomenclature/relations",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "NomenclatureRelatedDrugs"
                                  )
                                },
                              },
                            },
                            [_vm._v("Таблица связей")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("nomenclature/drug/comments")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/nomenclature/drug/comments",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "NomenclatureDrugComments"
                                  )
                                },
                              },
                            },
                            [_vm._v("Комментарии")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("reports")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/reports" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Отчеты\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("reports/all")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("newReports")
                                },
                              },
                            },
                            [_vm._v("\n            Общий отчет\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/nonCash")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/reports/non-cash",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("ReportNonCash")
                                },
                              },
                            },
                            [_vm._v("\n            Безналичный\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/history")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/reports/history",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("HistoryReports")
                                },
                              },
                            },
                            [_vm._v("\n            История\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/countryDrug")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "CountryDrugReport"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Страны закупок\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/all")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("PeriodReport")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Отчет за период\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("runners/report")
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                                "active-url": "/runners/report",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "RunnerCurrentReport"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Отчет по городу(дивизиону)\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/cashbox")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/reports/cashbox",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("Cashbox")
                                },
                              },
                            },
                            [_vm._v("\n            Касса\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/new")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("mainReports")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Общий отчет (старый)\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/expenses")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("expensesReport")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Расходы за период\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/AgentDaily")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/reports/AgentDaily",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("AgentDailyReport")
                                },
                              },
                            },
                            [_vm._v("\n            Дневной отчет\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/AgentPeriod")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/reports/AgentPeriod",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "AgentPeriodReport"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Отчет за период\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/Conversions")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/reports/conversions",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "ReportConversions"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Конверсия\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/salesFunnel")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/reports/salesFunnel",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "ReportSalesFunnel"
                                  )
                                },
                              },
                            },
                            [_vm._v("Воронка")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("reports/AgentPeriodDrug")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/reports/AgentPeriod/drug",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "AgentPeriodDrugReport"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Отчет по препарату\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("uploads")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/uploads" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-dashboard" }),
                          _vm._v("Справочные\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("uploadsDeals")
                            },
                          },
                        },
                        [_vm._v("\n            Договоры\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            "active-url": "/uploads/blackList",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("uploadsBlackList")
                            },
                          },
                        },
                        [_vm._v("\n            Черный список\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            "active-url": "/uploads/manageb",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter(
                                "uploadsManageBlackList"
                              )
                            },
                          },
                        },
                        [_vm._v("\n            ЧС динамический\n          ")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("invoices")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/invoices" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-list-ol" }),
                          _vm._v("Накладные\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("invoices/create")
                        ? _c(
                            "a",
                            {
                              class: {
                                active: _vm.$route.fullPath === "/invoices/new",
                              },
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("InvoicesNew")
                                },
                              },
                            },
                            [_vm._v("\n            Создать\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          class: {
                            active:
                              _vm.$route.fullPath === "/invoices/list/all",
                          },
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("InvoicesList", {
                                type: "all",
                              })
                            },
                          },
                        },
                        [_vm._v("\n            Просмотреть\n          ")]
                      ),
                      _vm._v(" "),
                      this.$can("costPrice")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("CostPrice")
                                },
                              },
                            },
                            [_vm._v("\n            Себестоимость\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("supply/orders")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("SupplyOrders")
                                },
                              },
                            },
                            [_vm._v("\n            Закупки\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("suppliers")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("Suppliers")
                                },
                              },
                            },
                            [_vm._v("\n            Поставщики\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("suppliers/countries")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "SuppliersCountries"
                                  )
                                },
                              },
                            },
                            [_vm._v("Страны поставки")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("sms/settings")
                ? _c("v-collapse-item", { attrs: { "active-url": "/sms" } }, [
                    _c(
                      "a",
                      {
                        attrs: { slot: "item-title", href: "#" },
                        slot: "item-title",
                      },
                      [
                        _c("i", { staticClass: "icon-ln icon-ln-doc" }),
                        _vm._v("SMS\n            "),
                        _c("span", { staticClass: "icon-fa arrow icon-fa-fw" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-sms" }),
                      ]
                    ),
                    _vm._v(" "),
                    this.$can("sms/manage")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("manageSMS")
                              },
                            },
                          },
                          [_vm._v("\n            Управление SMS\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("sms/sended")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("sendedSMS")
                              },
                            },
                          },
                          [_vm._v("\n            Отправленные SMS\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("sms/manage")
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("segmentsSMS")
                              },
                            },
                          },
                          [_vm._v("\n            Сегменты\n          ")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$can("settings")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/admin/receipts" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-ln icon-ln-doc" }),
                          _vm._v("Рецепты\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("receipts/templates")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("ReceiptTemplates")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Шаблоны рецептов\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("receipts/print")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("CreateReceipt")
                                },
                              },
                            },
                            [_vm._v("\n            Печать рецепта\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("receipts/statistics")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "ReceiptsStatistics"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Статистика рецептов\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("cards")
                ? _c("v-collapse-item", { attrs: { "active-url": "/cards" } }, [
                    _c(
                      "a",
                      {
                        attrs: { slot: "item-title", href: "#" },
                        slot: "item-title",
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-credit-card" }),
                        _vm._v("Карты\n            "),
                        _c("span", { staticClass: "icon-fa arrow icon-fa-fw" }),
                        _vm._v(" "),
                        _vm.$ActiveNotifications &&
                        +_vm.$ActiveNotifications.bankSMS
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "badge badge-info order_info_badge",
                              },
                              [_vm._v(_vm._s(_vm.$ActiveNotifications.bankSMS))]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    this.$can("cards/list")
                      ? _c(
                          "a",
                          {
                            class: {
                              active: _vm.$route.fullPath === "/cards/show",
                            },
                            attrs: { href: "#", "active-url": "/cards/show" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("settingsCardsNew")
                              },
                            },
                          },
                          [_vm._v("Кредитные карты")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("cards/cashout")
                      ? _c(
                          "a",
                          {
                            class: {
                              active: _vm.$route.fullPath === "/cards/cashout",
                            },
                            attrs: {
                              href: "#",
                              "active-url": "/cards/cashout",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("CardsCashOut")
                              },
                            },
                          },
                          [_vm._v("Обналичивание")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("cards/sms")
                      ? _c(
                          "a",
                          {
                            class: {
                              active: _vm.$route.fullPath === "/sms/service",
                            },
                            attrs: { href: "#", "active-url": "/sms/service" },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("bankSMS")
                              },
                            },
                          },
                          [
                            _vm.$ActiveNotifications &&
                            +_vm.$ActiveNotifications.bankSMS
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-info order_info_badge",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$ActiveNotifications.bankSMS)
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v("\n            Банковские SMS"),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("cards/statistics")
                      ? _c(
                          "a",
                          {
                            class: {
                              active: _vm.$route.fullPath === "/cards/report",
                            },
                            attrs: {
                              href: "#",
                              "active-url": "/settings/cards/report",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("NoCashCardReport")
                              },
                            },
                          },
                          [_vm._v("Статистика заявок б.н.")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("cards/transactions")
                      ? _c(
                          "a",
                          {
                            class: {
                              active:
                                _vm.$route.fullPath === "/cards/transactions",
                            },
                            attrs: {
                              href: "#",
                              "active-url": "/cards/transactions",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter("CardsTransactions")
                              },
                            },
                          },
                          [_vm._v("Оплаты счетов")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.$can("cards/statistics")
                      ? _c(
                          "a",
                          {
                            class: {
                              active:
                                _vm.$route.fullPath === "/cards/statistics",
                            },
                            attrs: {
                              href: "#",
                              "active-url": "/cards/statistics",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.mixinGoToRouter(
                                  "CardsTransactionsStatistics"
                                )
                              },
                            },
                          },
                          [_vm._v("Статистика переводов")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.$can("settings")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/settings" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-ln icon-ln-doc" }),
                          _vm._v("Настройки\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("settings/general")
                        ? _c(
                            "a",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/settings/general",
                              },
                              attrs: {
                                href: "#",
                                "active-url": "/settings/general",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("GeneralSettings")
                                },
                              },
                            },
                            [_vm._v("Общие настройки")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("settings/access")
                        ? _c(
                            "v-collapse-item",
                            { attrs: { "active-url": "/settings/invoices" } },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { slot: "item-title", href: "#" },
                                  slot: "item-title",
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-ln icon-ln-doc",
                                  }),
                                  _vm._v("Накладные\n              "),
                                  _c("span", {
                                    staticClass: "icon-fa arrow icon-fa-fw",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              this.$can("settings")
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "active-url":
                                          "/settings/invoices/substatuses",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsInvoiceSubstatuses"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Подсклады\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("settings/access")
                        ? _c(
                            "v-collapse-item",
                            { attrs: { "active-url": "/settings/stores" } },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { slot: "item-title", href: "#" },
                                  slot: "item-title",
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-ln icon-ln-doc",
                                  }),
                                  _vm._v("Склады\n              "),
                                  _c("span", {
                                    staticClass: "icon-fa arrow icon-fa-fw",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              this.$can("settings")
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "active-url": "/settings/stores/main",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsStoresMain"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Настройки складов\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("settings")
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "active-url": "/settings/stores/cities",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsStoresCities"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Общие настройки\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("settings")
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "active-url":
                                          "/settings/stores/notifications",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "SettingsStoresTelegramNotifications"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Уведомления\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("settings")
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "active-url":
                                          "/settings/stores/workingtime",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "SettingsStoresWorkingTime"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              График работы\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("settings/access")
                        ? _c(
                            "v-collapse-item",
                            { attrs: { "active-url": "/settings/orders" } },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { slot: "item-title", href: "#" },
                                  slot: "item-title",
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-ln icon-ln-doc",
                                  }),
                                  _vm._v("Заявки\n              "),
                                  _c("span", {
                                    staticClass: "icon-fa arrow icon-fa-fw",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              this.$can("settings")
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "active-url":
                                          "/settings/orders/reserve",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsOrdersReserve"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Направления/Бронь\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("settings")
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "active-url": "/settings/orders/dprice",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsOrdersDeliveryPrice"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Стоимость доставки\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("settings/access")
                        ? _c(
                            "v-collapse-item",
                            {
                              attrs: { "active-url": "/admin/settings/access" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { slot: "item-title", href: "#" },
                                  slot: "item-title",
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-ln icon-ln-doc",
                                  }),
                                  _vm._v("Доступ\n              "),
                                  _c("span", {
                                    staticClass: "icon-fa arrow icon-fa-fw",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              this.$can("settings/access/users")
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#",
                                        "active-url":
                                          "/admin/settings/access/users#",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsAccessUsers"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Пользователи\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("settings/access/roles")
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsAccessRoles"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Роли\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("settings/access/redis")
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "SettingsAccessRedis"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Redis IP")]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-collapse-item",
                        { attrs: { "active-url": "/admin/settings/letters" } },
                        [
                          _c(
                            "a",
                            {
                              attrs: { slot: "item-title", href: "#" },
                              slot: "item-title",
                            },
                            [
                              _c("i", { staticClass: "icon-ln icon-ln-doc" }),
                              _vm._v("Письма\n              "),
                              _c("span", {
                                staticClass: "icon-fa arrow icon-fa-fw",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                                "active-url": "/admin/settings/letters/list",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "settingsLettersList"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Список писем\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-collapse-item",
                        { attrs: { "active-url": "/settings/currencies" } },
                        [
                          _c(
                            "a",
                            {
                              attrs: { slot: "item-title", href: "#" },
                              slot: "item-title",
                            },
                            [
                              _c("i", { staticClass: "icon-fa icon-fa-btc" }),
                              _vm._v("Валюты\n              "),
                              _c("span", {
                                staticClass: "icon-fa arrow icon-fa-fw",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#",
                                "active-url": "/settings/currencies/rates",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "settingsCurrenciesRates"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              Курсы\n            ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("tempTools")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/orders/byDrugs" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-ln icon-ln-doc" }),
                          _vm._v("Вр. инструмены\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("orders/search")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/orders/byDrugs" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("ordersByDrugs")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Заявки по городу\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/search")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "temporary/drugSets" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("ordersDrugSets")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Заявки с комплектами\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("orders/search")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "missingOrderDetails"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Потерянные детали\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("settings")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("inStore")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Остаток на складе\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("settings")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("temporaryTemp")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Препараты на почту\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("invoices/post/stickers")
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("PostStickers")
                                },
                              },
                            },
                            [_vm._v("Стикеры для накладных")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("telephony")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/telephony" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-volume-control-phone",
                          }),
                          _vm._v("Телефония\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("telephony/calls")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/telephony/calls" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("telephonyCalls")
                                },
                              },
                            },
                            [_vm._v("\n            Звонки\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("telephony/ipNumbers")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/telephony/list" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "telephonyIpNumbers"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            IP номера\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("telephony/sip")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/telephony/sip" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("telephonySip")
                                },
                              },
                            },
                            [_vm._v("\n            SIP аккаунты\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("telephony/bank")
                        ? _c(
                            "router-link",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/telephony/bank",
                              },
                              attrs: { to: "/telephony/bank" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("BankPhones")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Банковские номера\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("telephony/access")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/telephony/access" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("telephonyAccess")
                                },
                              },
                            },
                            [_vm._v("\n            Доступы\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("telephony/statistics")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/telephony/statistics" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "telephonyStatistics"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Статистика\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("statistics")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/statistics" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-area-chart",
                          }),
                          _vm._v("Статистика\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("statistics")
                        ? _c(
                            "v-collapse-item",
                            { attrs: { "active-url": "/statistics" } },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { slot: "item-title", href: "#" },
                                  slot: "item-title",
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-list",
                                  }),
                                  _vm._v("Заявки\n              "),
                                  _c("span", {
                                    staticClass: "icon-fa arrow icon-fa-fw",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              this.$can("statistics/orders")
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: { to: "/statistics/orders/all" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "statisticsOrders"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Все заявки\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("statistics/orders/chats")
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: { to: "/statistics/orders/chats" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "StatisticsChats"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Чаты с клиентами\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$can("statistics/orders/rejected")
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/statistics/orders/rejected",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "StatisticsRejectedOrders"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Отмены у менеджеров\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("statistics/detailedorders")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/statistics/detailedorders" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "statisticsDetailedOrders"
                                  )
                                },
                              },
                            },
                            [_vm._v("Заявки с деталями\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("statistics/postdirections")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/statistics/postdirections" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "statisticsPostDirections"
                                  )
                                },
                              },
                            },
                            [_vm._v("Почтовые направления\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("statistics/drugs")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/statistics/drugs" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("StatisticsDrugs")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Продажа препаратов\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("orders/search")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/phoneCalls/missed" } },
                    [
                      this.$can("orders/newOrder")
                        ? _c(
                            "a",
                            {
                              attrs: { slot: "item-title", href: "#" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("newMissedCalls")
                                },
                              },
                              slot: "item-title",
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-medkit",
                              }),
                              _vm._v("Пропущенные звонки\n            "),
                              +_vm.$dynamicData?.missCalls
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-warning order_info_badge",
                                    },
                                    [_vm._v(_vm._s(_vm.$dynamicData.missCalls))]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("clientRequests")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/customersRequests" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-volume-control-phone",
                          }),
                          _vm._v("Запросы пользователей\n            "),
                          +_vm.$dynamicData?.clientFromPhoneCallRequest
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-warning order_info_badge",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$dynamicData
                                          ?.clientFromPhoneCallRequest
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: { name: "CustomersOrderRequests" } } },
                        [_vm._v("\n            Спрос\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          attrs: { to: { name: "customersRequestsCallbacks" } },
                        },
                        [
                          _vm._v("\n            Обратные звонки\n            "),
                          +_vm.$dynamicData?.clientFromPhoneCallRequest
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-warning order_info_badge",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$dynamicData
                                          ?.clientFromPhoneCallRequest
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { name: "customersRequestsAvailables" },
                          },
                        },
                        [
                          _vm._v(
                            "\n            Наличие препаратов\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("clients/blackList")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/clients/blackList" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-ln icon-ln-doc" }),
                          _vm._v("Клиенты\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("clients/blackList")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/clients/blackList" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("ordersByDrugs")
                                },
                              },
                            },
                            [_vm._v("\n            Черный список\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("users/settings")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/users" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-users" }),
                          _vm._v("Сотрудники\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("users/list")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/list" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("UsersList")
                                },
                              },
                            },
                            [_vm._v("\n            Список\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/managers")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/managers" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("UsersManagers")
                                },
                              },
                            },
                            [_vm._v("\n            Менеджеры\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/managers/shifts")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/managers/shifts" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "ManagersShiftsActivation"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Активация смен\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/managers/groups")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/managers/groups" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "UsersManagersGroups"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Группы/Смены\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/managers/groups/history")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/managers/groups/history/" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "UsersManagersGroupsHistory"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Редактирование групп\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/salary")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/salary" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("UsersSalary")
                                },
                              },
                            },
                            [_vm._v("\n            Зарплата\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/salaryp")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/salaryp" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter(
                                    "UsersSalaryProspects"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Прогноз ЗП\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/shifts")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/shifts" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("WorkShifts")
                                },
                              },
                            },
                            [_vm._v("\n            Рабочие смены\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/managers")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/mtelegram" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("WorkShifts")
                                },
                              },
                            },
                            [_vm._v("\n            Telegram\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("users/agents")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/users/agents" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-users" }),
                          _vm._v("Агенты\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("users/agents/list")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/agents/list" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("UsersAgentsList")
                                },
                              },
                            },
                            [_vm._v("\n            Список\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("users/agents/group")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/users/agents/group" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("UsersAgentsGroup")
                                },
                              },
                            },
                            [_vm._v("\n            Моя группа\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("cod")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/cod" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-ln icon-ln-doc" }),
                          _vm._v("Наложенный платеж\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("cod/senders")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/cod/senders" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("CodSenders")
                                },
                              },
                            },
                            [_vm._v("\n            Отправители\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("cod/orders")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/cod/orders" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("CodOrders")
                                },
                              },
                            },
                            [_vm._v("\n            Заявки\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("cod/sent")
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: "/cod/sent" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("SentOrders")
                                },
                              },
                            },
                            [_vm._v("\n            Отправленные\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              this.$can("services")
                ? _c(
                    "v-collapse-item",
                    { attrs: { "active-url": "/services" } },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "item-title", href: "#" },
                          slot: "item-title",
                        },
                        [
                          _c("i", { staticClass: "icon-fa icon-fa-share-alt" }),
                          _vm._v("Сервисы\n            "),
                          _c("span", {
                            staticClass: "icon-fa arrow icon-fa-fw",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      this.$can("services/marketplaces")
                        ? _c(
                            "router-link",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath ===
                                  "/services/marketplaces",
                              },
                              attrs: { to: "/services/marketplaces" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("MarketPlaces")
                                },
                              },
                            },
                            [_vm._v("\n            Маркетплейсы\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("services/postUsers")
                        ? _c(
                            "router-link",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/services/postusers",
                              },
                              attrs: { to: "/services/postusers" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("ServicePostUsers")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            СДЭК дропы + карты\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.$can("services/proxies")
                        ? _c(
                            "router-link",
                            {
                              class: {
                                active:
                                  _vm.$route.fullPath === "/services/proxies",
                              },
                              attrs: { to: "/services/proxies" },
                              on: {
                                click: function ($event) {
                                  return _vm.mixinGoToRouter("ServiceProxies")
                                },
                              },
                            },
                            [_vm._v("\n            Прокси\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }